// ==========================================
// GONTERO - Données fictives portail client
// Carrières et matériaux
// ==========================================

export const entreprise = {
  nom: 'GONTERO',
  raisonSociale: 'GONTERO SAS',
  adresse: '245 Route des Carrières, 13400 Aubagne',
  telephone: '04 42 XX XX XX',
  email: 'contact@gontero.fr',
  siret: '123 456 789 00012',
  tvaIntra: 'FR 12 345678900',
};

export const clientConnecte = {
  id: 'CLI-001',
  raisonSociale: 'BTP MÉDITERRANÉE',
  nom: 'Durand',
  prenom: 'Albert',
  email: 'a.durand@btpmed.fr',
  telephone: '04 91 XX XX XX',
  portable: '06 12 XX XX XX',
  adresse: '15 Avenue du Prado',
  codePostal: '13008',
  ville: 'Marseille',
  siret: '987 654 321 00015',
  tvaIntra: 'FR 98 765432100',
  conditionsPaiement: {
    delai: 30,
    mode: 'Virement bancaire',
    escompte: '0%',
    penalitesRetard: '3 fois le taux d\'intérêt légal',
    remise: '5% sur granulats > 50T',
  },
  dateCreation: '2019-03-15',
  commercial: 'Jean-Marc Gontero',
};

export const encours = {
  totalDu: 15847.60,
  echeanceProcheDate: '2026-04-25',
  echeanceProcheMontant: 4230.00,
  facturesEnRetard: 2,
  montantRetard: 3420.80,
};

export const materiaux = [
  { code: 'SAB-01', nom: 'Sable 0/4 lavé', unite: 'T', prix: 12.50 },
  { code: 'SAB-02', nom: 'Sable 0/2 fin', unite: 'T', prix: 14.80 },
  { code: 'GRA-01', nom: 'Gravier 4/8', unite: 'T', prix: 15.20 },
  { code: 'GRA-02', nom: 'Gravier 8/16', unite: 'T', prix: 14.50 },
  { code: 'GRA-03', nom: 'Gravier 16/22', unite: 'T', prix: 13.80 },
  { code: 'GNT-01', nom: 'GNT 0/31.5', unite: 'T', prix: 9.60 },
  { code: 'GNT-02', nom: 'GNT 0/20', unite: 'T', prix: 10.40 },
  { code: 'ENR-01', nom: 'Enrochement 100/400', unite: 'T', prix: 18.50 },
  { code: 'TOU-01', nom: 'Tout-venant 0/80', unite: 'T', prix: 7.20 },
  { code: 'GAL-01', nom: 'Galets 40/80', unite: 'T', prix: 22.00 },
];

export const factures = [
  {
    id: 'FAC-2026-0142',
    type: 'facture',
    date: '2026-04-10',
    echeance: '2026-05-10',
    montantHT: 3850.00,
    tva: 770.00,
    montantTTC: 4620.00,
    statut: 'en_attente',
    lignes: [
      { materiau: 'Sable 0/4 lavé', quantite: 120, unite: 'T', prixUnit: 12.50, montant: 1500.00 },
      { materiau: 'Gravier 4/8', quantite: 80, unite: 'T', prixUnit: 15.20, montant: 1216.00 },
      { materiau: 'GNT 0/31.5', quantite: 118, unite: 'T', prixUnit: 9.60, montant: 1132.80 },
    ],
    reference: 'Chantier Résidence Les Oliviers',
    bonCommande: 'BC-2026-0089',
    bonLivraison: 'BL-2026-0201',
  },
  {
    id: 'FAC-2026-0128',
    type: 'facture',
    date: '2026-03-25',
    echeance: '2026-04-25',
    montantHT: 3525.00,
    tva: 705.00,
    montantTTC: 4230.00,
    statut: 'en_attente',
    lignes: [
      { materiau: 'Gravier 8/16', quantite: 150, unite: 'T', prixUnit: 14.50, montant: 2175.00 },
      { materiau: 'Sable 0/2 fin', quantite: 45, unite: 'T', prixUnit: 14.80, montant: 666.00 },
      { materiau: 'Tout-venant 0/80', quantite: 95, unite: 'T', prixUnit: 7.20, montant: 684.00 },
    ],
    reference: 'Chantier ZAC Euroméd',
    bonCommande: 'BC-2026-0078',
    bonLivraison: 'BL-2026-0189',
  },
  {
    id: 'FAC-2026-0098',
    type: 'facture',
    date: '2026-02-28',
    echeance: '2026-03-30',
    montantHT: 1842.00,
    tva: 368.40,
    montantTTC: 2210.40,
    statut: 'en_retard',
    lignes: [
      { materiau: 'Enrochement 100/400', quantite: 62, unite: 'T', prixUnit: 18.50, montant: 1147.00 },
      { materiau: 'GNT 0/20', quantite: 45, unite: 'T', prixUnit: 10.40, montant: 468.00 },
      { materiau: 'Galets 40/80', quantite: 10.3, unite: 'T', prixUnit: 22.00, montant: 226.60 },
    ],
    reference: 'Chantier Port de la Joliette',
    bonCommande: 'BC-2026-0052',
    bonLivraison: 'BL-2026-0145',
  },
  {
    id: 'FAC-2026-0071',
    type: 'facture',
    date: '2026-02-10',
    echeance: '2026-03-12',
    montantHT: 1008.67,
    tva: 201.73,
    montantTTC: 1210.40,
    statut: 'en_retard',
    lignes: [
      { materiau: 'Sable 0/4 lavé', quantite: 45, unite: 'T', prixUnit: 12.50, montant: 562.50 },
      { materiau: 'Gravier 16/22', quantite: 32.3, unite: 'T', prixUnit: 13.80, montant: 445.74 },
    ],
    reference: 'Chantier Voirie Commune Cassis',
    bonCommande: 'BC-2026-0041',
    bonLivraison: 'BL-2026-0112',
  },
  {
    id: 'FAC-2025-0412',
    type: 'facture',
    date: '2025-12-15',
    echeance: '2026-01-15',
    montantHT: 5640.00,
    tva: 1128.00,
    montantTTC: 6768.00,
    statut: 'payee',
    lignes: [
      { materiau: 'GNT 0/31.5', quantite: 250, unite: 'T', prixUnit: 9.60, montant: 2400.00 },
      { materiau: 'Gravier 4/8', quantite: 120, unite: 'T', prixUnit: 15.20, montant: 1824.00 },
      { materiau: 'Sable 0/4 lavé', quantite: 80, unite: 'T', prixUnit: 12.50, montant: 1000.00 },
      { materiau: 'Tout-venant 0/80', quantite: 57.78, unite: 'T', prixUnit: 7.20, montant: 416.00 },
    ],
    reference: 'Chantier Lotissement Calanques',
    bonCommande: 'BC-2025-0389',
    bonLivraison: 'BL-2025-0498',
  },
  {
    id: 'FAC-2025-0380',
    type: 'facture',
    date: '2025-11-20',
    echeance: '2025-12-20',
    montantHT: 2890.00,
    tva: 578.00,
    montantTTC: 3468.00,
    statut: 'payee',
    lignes: [
      { materiau: 'Gravier 8/16', quantite: 100, unite: 'T', prixUnit: 14.50, montant: 1450.00 },
      { materiau: 'Sable 0/2 fin', quantite: 60, unite: 'T', prixUnit: 14.80, montant: 888.00 },
      { materiau: 'GNT 0/20', quantite: 53.08, unite: 'T', prixUnit: 10.40, montant: 552.00 },
    ],
    reference: 'Chantier Boulevard Michelet',
    bonCommande: 'BC-2025-0361',
    bonLivraison: 'BL-2025-0472',
  },
];

export const bonsCommande = [
  {
    id: 'BC-2026-0089',
    type: 'bon_commande',
    date: '2026-04-05',
    montantHT: 3850.00,
    tva: 770.00,
    montantTTC: 4620.00,
    statut: 'livre',
    reference: 'Chantier Résidence Les Oliviers',
    carriere: 'Carrière d\'Aubagne',
    lignes: [
      { materiau: 'Sable 0/4 lavé', quantite: 120, unite: 'T', prixUnit: 12.50, montant: 1500.00 },
      { materiau: 'Gravier 4/8', quantite: 80, unite: 'T', prixUnit: 15.20, montant: 1216.00 },
      { materiau: 'GNT 0/31.5', quantite: 118, unite: 'T', prixUnit: 9.60, montant: 1132.80 },
    ],
    facture: 'FAC-2026-0142',
    bonLivraison: 'BL-2026-0201',
  },
  {
    id: 'BC-2026-0078',
    type: 'bon_commande',
    date: '2026-03-18',
    montantHT: 3525.00,
    tva: 705.00,
    montantTTC: 4230.00,
    statut: 'livre',
    reference: 'Chantier ZAC Euroméd',
    carriere: 'Carrière de Gémenos',
    lignes: [
      { materiau: 'Gravier 8/16', quantite: 150, unite: 'T', prixUnit: 14.50, montant: 2175.00 },
      { materiau: 'Sable 0/2 fin', quantite: 45, unite: 'T', prixUnit: 14.80, montant: 666.00 },
      { materiau: 'Tout-venant 0/80', quantite: 95, unite: 'T', prixUnit: 7.20, montant: 684.00 },
    ],
    facture: 'FAC-2026-0128',
    bonLivraison: 'BL-2026-0189',
  },
  {
    id: 'BC-2026-0095',
    type: 'bon_commande',
    date: '2026-04-12',
    montantHT: 2680.00,
    tva: 536.00,
    montantTTC: 3216.00,
    statut: 'en_cours',
    reference: 'Chantier Extension Port',
    carriere: 'Carrière d\'Aubagne',
    lignes: [
      { materiau: 'Enrochement 100/400', quantite: 100, unite: 'T', prixUnit: 18.50, montant: 1850.00 },
      { materiau: 'GNT 0/31.5', quantite: 86.46, unite: 'T', prixUnit: 9.60, montant: 830.00 },
    ],
    facture: null,
    bonLivraison: null,
  },
  {
    id: 'BC-2026-0052',
    type: 'bon_commande',
    date: '2026-02-20',
    montantHT: 1842.00,
    tva: 368.40,
    montantTTC: 2210.40,
    statut: 'livre',
    reference: 'Chantier Port de la Joliette',
    carriere: 'Carrière de Gémenos',
    lignes: [
      { materiau: 'Enrochement 100/400', quantite: 62, unite: 'T', prixUnit: 18.50, montant: 1147.00 },
      { materiau: 'GNT 0/20', quantite: 45, unite: 'T', prixUnit: 10.40, montant: 468.00 },
      { materiau: 'Galets 40/80', quantite: 10.3, unite: 'T', prixUnit: 22.00, montant: 226.60 },
    ],
    facture: 'FAC-2026-0098',
    bonLivraison: 'BL-2026-0145',
  },
  {
    id: 'BC-2026-0041',
    type: 'bon_commande',
    date: '2026-02-05',
    montantHT: 1008.67,
    tva: 201.73,
    montantTTC: 1210.40,
    statut: 'livre',
    reference: 'Chantier Voirie Commune Cassis',
    carriere: 'Carrière d\'Aubagne',
    lignes: [
      { materiau: 'Sable 0/4 lavé', quantite: 45, unite: 'T', prixUnit: 12.50, montant: 562.50 },
      { materiau: 'Gravier 16/22', quantite: 32.3, unite: 'T', prixUnit: 13.80, montant: 445.74 },
    ],
    facture: 'FAC-2026-0071',
    bonLivraison: 'BL-2026-0112',
  },
];

export const bonsLivraison = [
  {
    id: 'BL-2026-0201',
    type: 'bon_livraison',
    date: '2026-04-08',
    statut: 'livre',
    reference: 'Chantier Résidence Les Oliviers',
    adresseLivraison: '28 Chemin des Oliviers, 13009 Marseille',
    carriere: 'Carrière d\'Aubagne',
    chauffeur: 'Martinez L.',
    immatriculation: 'FG-456-HJ',
    heureDepart: '07:30',
    heureArrivee: '08:45',
    lignes: [
      { materiau: 'Sable 0/4 lavé', quantiteCommandee: 120, quantiteLivree: 120.5, unite: 'T' },
      { materiau: 'Gravier 4/8', quantiteCommandee: 80, quantiteLivree: 79.8, unite: 'T' },
      { materiau: 'GNT 0/31.5', quantiteCommandee: 118, quantiteLivree: 118.2, unite: 'T' },
    ],
    bonCommande: 'BC-2026-0089',
    facture: 'FAC-2026-0142',
    signataireClient: 'P. Durand',
    observations: 'RAS - Livraison conforme',
  },
  {
    id: 'BL-2026-0189',
    type: 'bon_livraison',
    date: '2026-03-22',
    statut: 'livre',
    reference: 'Chantier ZAC Euroméd',
    adresseLivraison: '12 Rue de la République, 13002 Marseille',
    carriere: 'Carrière de Gémenos',
    chauffeur: 'Rossi P.',
    immatriculation: 'EK-789-LM',
    heureDepart: '06:45',
    heureArrivee: '08:15',
    lignes: [
      { materiau: 'Gravier 8/16', quantiteCommandee: 150, quantiteLivree: 150.3, unite: 'T' },
      { materiau: 'Sable 0/2 fin', quantiteCommandee: 45, quantiteLivree: 44.8, unite: 'T' },
      { materiau: 'Tout-venant 0/80', quantiteCommandee: 95, quantiteLivree: 95.1, unite: 'T' },
    ],
    bonCommande: 'BC-2026-0078',
    facture: 'FAC-2026-0128',
    signataireClient: 'P. Durand',
    observations: '',
  },
  {
    id: 'BL-2026-0145',
    type: 'bon_livraison',
    date: '2026-02-25',
    statut: 'livre',
    reference: 'Chantier Port de la Joliette',
    adresseLivraison: 'Quai du Port, 13002 Marseille',
    carriere: 'Carrière de Gémenos',
    chauffeur: 'Martinez L.',
    immatriculation: 'FG-456-HJ',
    heureDepart: '07:00',
    heureArrivee: '08:30',
    lignes: [
      { materiau: 'Enrochement 100/400', quantiteCommandee: 62, quantiteLivree: 62.4, unite: 'T' },
      { materiau: 'GNT 0/20', quantiteCommandee: 45, quantiteLivree: 45.0, unite: 'T' },
      { materiau: 'Galets 40/80', quantiteCommandee: 10.3, quantiteLivree: 10.5, unite: 'T' },
    ],
    bonCommande: 'BC-2026-0052',
    facture: 'FAC-2026-0098',
    signataireClient: 'P. Durand',
    observations: 'Accès chantier difficile - attente 30min',
  },
  {
    id: 'BL-2026-0112',
    type: 'bon_livraison',
    date: '2026-02-08',
    statut: 'livre',
    reference: 'Chantier Voirie Commune Cassis',
    adresseLivraison: 'Route des Crêtes, 13260 Cassis',
    carriere: 'Carrière d\'Aubagne',
    chauffeur: 'Blanc T.',
    immatriculation: 'DL-123-NP',
    heureDepart: '08:00',
    heureArrivee: '09:00',
    lignes: [
      { materiau: 'Sable 0/4 lavé', quantiteCommandee: 45, quantiteLivree: 45.2, unite: 'T' },
      { materiau: 'Gravier 16/22', quantiteCommandee: 32.3, quantiteLivree: 32.1, unite: 'T' },
    ],
    bonCommande: 'BC-2026-0041',
    facture: 'FAC-2026-0071',
    signataireClient: 'M. Lefèvre (chef chantier)',
    observations: '',
  },
];

export const historiqueReglements = [
  { date: '2026-01-20', montant: 6768.00, mode: 'Virement', reference: 'FAC-2025-0412' },
  { date: '2025-12-28', montant: 3468.00, mode: 'Virement', reference: 'FAC-2025-0380' },
  { date: '2025-11-15', montant: 4850.00, mode: 'Carte bancaire', reference: 'FAC-2025-0342' },
  { date: '2025-10-22', montant: 2340.00, mode: 'Virement', reference: 'FAC-2025-0298' },
];

// ==========================================
// Carrières et tarification par zone
// ==========================================

export const carrieres = [
  { id: 'SETEG', nom: 'SETEG', adresse: 'Quartier Saint-Pierre, 13400 Aubagne' },
  { id: 'LA_MEDE', nom: 'LA MÈDE', adresse: 'Route de la Mède, 13220 Châteauneuf-les-Martigues' },
  { id: 'SALON', nom: 'SALON', adresse: 'Route de Pélissanne, 13300 Salon-de-Provence' },
];

export const zones = [
  { id: 1, label: 'Zone 1', distance: '0 - 10 km' },
  { id: 2, label: 'Zone 2', distance: '10 - 20 km' },
  { id: 3, label: 'Zone 3', distance: '20 - 30 km' },
  { id: 4, label: 'Zone 4', distance: '30 - 40 km' },
  { id: 5, label: 'Zone 5', distance: '40 - 55 km' },
  { id: 6, label: 'Zone 6', distance: '55 - 70 km' },
  { id: 7, label: 'Zone 7', distance: '70 - 90 km' },
  { id: 8, label: 'Zone 8', distance: '90 - 110 km' },
  { id: 9, label: 'Zone 9', distance: '110 - 140 km' },
  { id: 10, label: 'Zone 10', distance: '140 km et +' },
];

export const produitsTarifs = [
  {
    code: 'SAB-01',
    nom: 'Sable 0/4 lavé',
    categorie: 'Sables',
    unite: 'T',
    carrieres: ['SETEG', 'LA_MEDE', 'SALON'],
    prixParZone: {
      SETEG:    [12.50, 15.80, 18.40, 21.00, 24.50, 28.00, 32.50, 37.00, 42.50, 49.00],
      LA_MEDE:  [13.00, 16.20, 18.90, 21.50, 25.00, 28.50, 33.00, 37.50, 43.00, 49.50],
      SALON:    [12.80, 16.00, 18.60, 21.20, 24.80, 28.20, 32.80, 37.20, 42.80, 49.20],
    },
  },
  {
    code: 'SAB-02',
    nom: 'Sable 0/2 fin',
    categorie: 'Sables',
    unite: 'T',
    carrieres: ['SETEG', 'SALON'],
    prixParZone: {
      SETEG:    [14.80, 18.10, 20.70, 23.30, 26.80, 30.30, 34.80, 39.30, 44.80, 51.30],
      SALON:    [15.00, 18.30, 20.90, 23.50, 27.00, 30.50, 35.00, 39.50, 45.00, 51.50],
    },
  },
  {
    code: 'GRA-01',
    nom: 'Gravier 4/8',
    categorie: 'Graviers',
    unite: 'T',
    carrieres: ['SETEG', 'LA_MEDE', 'SALON'],
    prixParZone: {
      SETEG:    [15.20, 18.50, 21.10, 23.70, 27.20, 30.70, 35.20, 39.70, 45.20, 51.70],
      LA_MEDE:  [15.50, 18.80, 21.40, 24.00, 27.50, 31.00, 35.50, 40.00, 45.50, 52.00],
      SALON:    [15.40, 18.70, 21.30, 23.90, 27.40, 30.90, 35.40, 39.90, 45.40, 51.90],
    },
  },
  {
    code: 'GRA-02',
    nom: 'Gravier 8/16',
    categorie: 'Graviers',
    unite: 'T',
    carrieres: ['SETEG', 'LA_MEDE', 'SALON'],
    prixParZone: {
      SETEG:    [14.50, 17.80, 20.40, 23.00, 26.50, 30.00, 34.50, 39.00, 44.50, 51.00],
      LA_MEDE:  [14.80, 18.10, 20.70, 23.30, 26.80, 30.30, 34.80, 39.30, 44.80, 51.30],
      SALON:    [14.70, 18.00, 20.60, 23.20, 26.70, 30.20, 34.70, 39.20, 44.70, 51.20],
    },
  },
  {
    code: 'GRA-03',
    nom: 'Gravier 16/22',
    categorie: 'Graviers',
    unite: 'T',
    carrieres: ['SETEG', 'LA_MEDE'],
    prixParZone: {
      SETEG:    [13.80, 17.10, 19.70, 22.30, 25.80, 29.30, 33.80, 38.30, 43.80, 50.30],
      LA_MEDE:  [14.00, 17.30, 19.90, 22.50, 26.00, 29.50, 34.00, 38.50, 44.00, 50.50],
    },
  },
  {
    code: 'GNT-01',
    nom: 'GNT 0/31.5',
    categorie: 'GNT',
    unite: 'T',
    carrieres: ['SETEG', 'LA_MEDE', 'SALON'],
    prixParZone: {
      SETEG:    [9.60, 12.90, 15.50, 18.10, 21.60, 25.10, 29.60, 34.10, 39.60, 46.10],
      LA_MEDE:  [9.90, 13.20, 15.80, 18.40, 21.90, 25.40, 29.90, 34.40, 39.90, 46.40],
      SALON:    [9.80, 13.10, 15.70, 18.30, 21.80, 25.30, 29.80, 34.30, 39.80, 46.30],
    },
  },
  {
    code: 'GNT-02',
    nom: 'GNT 0/20',
    categorie: 'GNT',
    unite: 'T',
    carrieres: ['SETEG', 'SALON'],
    prixParZone: {
      SETEG:    [10.40, 13.70, 16.30, 18.90, 22.40, 25.90, 30.40, 34.90, 40.40, 46.90],
      SALON:    [10.60, 13.90, 16.50, 19.10, 22.60, 26.10, 30.60, 35.10, 40.60, 47.10],
    },
  },
  {
    code: 'ENR-01',
    nom: 'Enrochement 100/400',
    categorie: 'Enrochements',
    unite: 'T',
    carrieres: ['SETEG', 'LA_MEDE'],
    prixParZone: {
      SETEG:    [18.50, 21.80, 24.40, 27.00, 30.50, 34.00, 38.50, 43.00, 48.50, 55.00],
      LA_MEDE:  [19.00, 22.30, 24.90, 27.50, 31.00, 34.50, 39.00, 43.50, 49.00, 55.50],
    },
  },
  {
    code: 'TOU-01',
    nom: 'Tout-venant 0/80',
    categorie: 'Tout-venant',
    unite: 'T',
    carrieres: ['SETEG', 'LA_MEDE', 'SALON'],
    prixParZone: {
      SETEG:    [7.20, 10.50, 13.10, 15.70, 19.20, 22.70, 27.20, 31.70, 37.20, 43.70],
      LA_MEDE:  [7.50, 10.80, 13.40, 16.00, 19.50, 23.00, 27.50, 32.00, 37.50, 44.00],
      SALON:    [7.40, 10.70, 13.30, 15.90, 19.40, 22.90, 27.40, 31.90, 37.40, 43.90],
    },
  },
  {
    code: 'GAL-01',
    nom: 'Galets 40/80',
    categorie: 'Galets',
    unite: 'T',
    carrieres: ['LA_MEDE'],
    prixParZone: {
      LA_MEDE:  [22.00, 25.30, 27.90, 30.50, 34.00, 37.50, 42.00, 46.50, 52.00, 58.50],
    },
  },
];

export const formatMontant = (montant) => {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(montant);
};

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const getStatutLabel = (statut) => {
  const labels = {
    en_attente: 'En attente',
    en_retard: 'En retard',
    payee: 'Payée',
    en_cours: 'En cours',
    livre: 'Livré',
    annulee: 'Annulée',
    validee: 'Validée',
  };
  return labels[statut] || statut;
};

export const getStatutColor = (statut) => {
  const colors = {
    en_attente: { bg: '#FEF3C7', color: '#92400E', border: '#FDE68A' },
    en_retard: { bg: '#FEE2E2', color: '#991B1B', border: '#FECACA' },
    payee: { bg: '#D1FAE5', color: '#065F46', border: '#A7F3D0' },
    en_cours: { bg: '#DBEAFE', color: '#1E40AF', border: '#BFDBFE' },
    livre: { bg: '#D1FAE5', color: '#065F46', border: '#A7F3D0' },
    annulee: { bg: '#F3F4F6', color: '#6B7280', border: '#E5E7EB' },
    validee: { bg: '#DBEAFE', color: '#1E40AF', border: '#BFDBFE' },
  };
  return colors[statut] || { bg: '#F3F4F6', color: '#6B7280', border: '#E5E7EB' };
};
